// @ts-ignore
var $1b47f5dea7b52a6c$exports = {};
!function(n) {
    "use strict";
    function t(n, t, r) {
        return r.a = n, r.f = t, r;
    }
    function F2(n) {
        return t(2, n, function(t) {
            return function(r) {
                return n(t, r);
            };
        });
    }
    function F3(n) {
        return t(3, n, function(t) {
            return function(r) {
                return function(e) {
                    return n(t, r, e);
                };
            };
        });
    }
    function F4(n) {
        return t(4, n, function(t) {
            return function(r) {
                return function(e) {
                    return function(i) {
                        return n(t, r, e, i);
                    };
                };
            };
        });
    }
    function F5(n) {
        return t(5, n, function(t) {
            return function(r) {
                return function(e) {
                    return function(i) {
                        return function(u) {
                            return n(t, r, e, i, u);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return t(6, n, function(t) {
            return function(r) {
                return function(e) {
                    return function(i) {
                        return function(u) {
                            return function(o) {
                                return n(t, r, e, i, u, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, t, r) {
        return 2 === n.a ? n.f(t, r) : n(t)(r);
    }
    function A3(n, t, r, e) {
        return 3 === n.a ? n.f(t, r, e) : n(t)(r)(e);
    }
    function A4(n, t, r, e, i) {
        return 4 === n.a ? n.f(t, r, e, i) : n(t)(r)(e)(i);
    }
    function A5(n, t, r, e, i, u) {
        return 5 === n.a ? n.f(t, r, e, i, u) : n(t)(r)(e)(i)(u);
    }
    function A6(n, t, r, e, i, u, o) {
        return 6 === n.a ? n.f(t, r, e, i, u, o) : n(t)(r)(e)(i)(u)(o);
    }
    function r(n, t, e, i) {
        if (n === t) return !0;
        if ("object" != typeof n || null === n || null === t) return "function" == typeof n && p(5), !1;
        if (e > 100) return i.push(u(n, t)), !0;
        for(var o in 0 > n.$ && (n = it(n), t = it(t)), n)if (!r(n[o], t[o], e + 1, i)) return !1;
        return !0;
    }
    function e(n, t, r) {
        if ("object" != typeof n) return n === t ? 0 : t > n ? -1 : 1;
        if (void 0 === n.$) return (r = e(n.a, t.a)) || (r = e(n.b, t.b)) ? r : e(n.c, t.c);
        for(; n.b && t.b && !(r = e(n.a, t.a)); n = n.b, t = t.b);
        return r || (n.b ? 1 : t.b ? -1 : 0);
    }
    var i = F2(function(n, t) {
        var r = e(n, t);
        return 0 > r ? tt : r ? nt : Zn;
    });
    function u(n, t) {
        return {
            a: n,
            b: t
        };
    }
    function o(n, t, r) {
        return {
            a: n,
            b: t,
            c: r
        };
    }
    var a = F2(c);
    function c(n, t) {
        if ("string" == typeof n) return n + t;
        if (!n.b) return t;
        var r = s(n.a, t);
        n = n.b;
        for(var e = r; n.b; n = n.b)e = e.b = s(n.a, t);
        return r;
    }
    var f = {
        $: 0
    };
    function s(n, t) {
        return {
            $: 1,
            a: n,
            b: t
        };
    }
    var l = F2(s);
    function d(n) {
        for(var t = f, r = n.length; r--;)t = s(n[r], t);
        return t;
    }
    var b = F3(function(n, t, r) {
        for(var e = []; t.b && r.b; t = t.b, r = r.b)e.push(A2(n, t.a, r.a));
        return d(e);
    }), v = F3(function(n, t, r) {
        for(var e = Array(n), i = 0; n > i; i++)e[i] = r(t + i);
        return e;
    }), h = F2(function(n, t) {
        for(var r = Array(n), e = 0; n > e && t.b; e++)r[e] = t.a, t = t.b;
        return r.length = e, u(r, t);
    });
    function p(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var g = Math.ceil, m = Math.floor, y = Math.log, $ = F2(function(n, t) {
        return t.split(n);
    }), w = F2(function(n, t) {
        return t.join(n);
    }), k = F2(function(n, t) {
        for(var r = t.length; r--;){
            var e = t[r], i = t.charCodeAt(r);
            if (56320 > i || i > 57343 || (e = t[--r] + e), !n(e)) return !1;
        }
        return !0;
    }), _ = F2(function(n, t) {
        return t.indexOf(n) > -1;
    });
    function A(n) {
        return n + "";
    }
    function x(n) {
        return {
            $: 2,
            b: n
        };
    }
    var j = x(function(n) {
        return "number" != typeof n ? X("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? ft(n) : !isFinite(n) || n % 1 ? X("an INT", n) : ft(n);
    }), q = x(function(n) {
        return "boolean" == typeof n ? ft(n) : X("a BOOL", n);
    }), N = x(function(n) {
        return "number" == typeof n ? ft(n) : X("a FLOAT", n);
    }), T = x(function(n) {
        return ft(n);
    }), O = x(function(n) {
        return "string" == typeof n ? ft(n) : n instanceof String ? ft(n + "") : X("a STRING", n);
    }), z = F2(function(n, t) {
        return {
            $: 6,
            d: n,
            b: t
        };
    });
    function E(n, t) {
        return {
            $: 9,
            f: n,
            g: t
        };
    }
    var L = F2(function(n, t) {
        return {
            $: 10,
            b: t,
            h: n
        };
    }), S = F2(function(n, t) {
        return E(n, [
            t
        ]);
    }), C = F3(function(n, t, r) {
        return E(n, [
            t,
            r
        ]);
    }), F = F4(function(n, t, r, e) {
        return E(n, [
            t,
            r,
            e
        ]);
    }), B = F5(function(n, t, r, e, i) {
        return E(n, [
            t,
            r,
            e,
            i
        ]);
    }), D = F6(function(n, t, r, e, i, u) {
        return E(n, [
            t,
            r,
            e,
            i,
            u
        ]);
    }), M = F2(function(n, t) {
        try {
            return R(n, JSON.parse(t));
        } catch (n) {
            return ut(A2(ot, "This is not valid JSON! " + n.message, t));
        }
    }), I = F2(function(n, t) {
        return R(n, t);
    });
    function R(n, t) {
        switch(n.$){
            case 2:
                return n.b(t);
            case 5:
                return null === t ? ft(n.c) : X("null", t);
            case 3:
                return J(t) ? W(n.b, t, d) : X("a LIST", t);
            case 4:
                return J(t) ? W(n.b, t, P) : X("an ARRAY", t);
            case 6:
                var r = n.d;
                if ("object" != typeof t || null === t || !(r in t)) return X("an OBJECT with a field named `" + r + "`", t);
                var e = R(n.b, t[r]);
                return Kt(e) ? e : ut(A2(at, r, e.a));
            case 7:
                var i = n.e;
                return J(t) ? t.length > i ? (e = R(n.b, t[i]), Kt(e) ? e : ut(A2(ct, i, e.a))) : X("a LONGER array. Need index " + i + " but only see " + t.length + " entries", t) : X("an ARRAY", t);
            case 8:
                if ("object" != typeof t || null === t || J(t)) return X("an OBJECT", t);
                var o = f;
                for(var a in t)if (t.hasOwnProperty(a)) {
                    if (e = R(n.b, t[a]), !Kt(e)) return ut(A2(at, a, e.a));
                    o = s(u(a, e.a), o);
                }
                return ft(Ot(o));
            case 9:
                for(var c = n.f, l = n.g, b = 0; l.length > b; b++){
                    if (e = R(l[b], t), !Kt(e)) return e;
                    c = c(e.a);
                }
                return ft(c);
            case 10:
                return e = R(n.b, t), Kt(e) ? R(n.h(e.a), t) : e;
            case 11:
                for(var v = f, h = n.g; h.b; h = h.b){
                    if (e = R(h.a, t), Kt(e)) return e;
                    v = s(e.a, v);
                }
                return ut(st(Ot(v)));
            case 1:
                return ut(A2(ot, n.a, t));
            case 0:
                return ft(n.a);
        }
    }
    function W(n, t, r) {
        for(var e = t.length, i = Array(e), u = 0; e > u; u++){
            var o = R(n, t[u]);
            if (!Kt(o)) return ut(A2(ct, u, o.a));
            i[u] = o.a;
        }
        return ft(r(i));
    }
    function J(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function P(n) {
        return A2(Vt, n.length, function(t) {
            return n[t];
        });
    }
    function X(n, t) {
        return ut(A2(ot, "Expecting " + n, t));
    }
    function G(n, t) {
        if (n === t) return !0;
        if (n.$ !== t.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === t.a;
            case 2:
                return n.b === t.b;
            case 5:
                return n.c === t.c;
            case 3:
            case 4:
            case 8:
                return G(n.b, t.b);
            case 6:
                return n.d === t.d && G(n.b, t.b);
            case 7:
                return n.e === t.e && G(n.b, t.b);
            case 9:
                return n.f === t.f && H(n.g, t.g);
            case 10:
                return n.h === t.h && G(n.b, t.b);
            case 11:
                return H(n.g, t.g);
        }
    }
    function H(n, t) {
        var r = n.length;
        if (r !== t.length) return !1;
        for(var e = 0; r > e; e++)if (!G(n[e], t[e])) return !1;
        return !0;
    }
    var U = F2(function(n, t) {
        return JSON.stringify(t, null, n) + "";
    });
    function Y(n) {
        return {
            $: 0,
            a: n
        };
    }
    function V(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var K = F2(function(n, t) {
        return {
            $: 3,
            b: n,
            d: t
        };
    }), Q = 0;
    function Z(n) {
        var t = {
            $: 0,
            e: Q++,
            f: n,
            g: null,
            h: []
        };
        return rn(t), t;
    }
    var nn = !1, tn = [];
    function rn(n) {
        if (tn.push(n), !nn) {
            for(nn = !0; n = tn.shift();)en(n);
            nn = !1;
        }
    }
    function en(n) {
        for(; n.f;){
            var t = n.f.$;
            if (0 === t || 1 === t) {
                for(; n.g && n.g.$ !== t;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === t) return void (n.f.c = n.f.b(function(t) {
                    n.f = t, rn(n);
                }));
                if (5 === t) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === t ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var un = {};
    function on(n, t) {
        var r = {
            g: t,
            h: void 0
        }, e = n.c, i = n.d, u = n.e, o = n.f;
        function a(n) {
            return A2(K, a, {
                $: 5,
                b: function(t) {
                    var a = t.a;
                    return 0 === t.$ ? A3(i, r, a, n) : u && o ? A4(e, r, a.i, a.j, n) : A3(e, r, u ? a.i : a.j, n);
                }
            });
        }
        return r.h = Z(A2(K, a, n.b));
    }
    var an = F2(function(n, t) {
        return V(function(r) {
            n.g(t), r(Y(0));
        });
    });
    function cn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var fn = [], sn = !1;
    function ln(n, t, r) {
        if (fn.push({
            p: n,
            q: t,
            r: r
        }), !sn) {
            sn = !0;
            for(var e; e = fn.shift();)dn(e.p, e.q, e.r);
            sn = !1;
        }
    }
    function dn(n, t, r) {
        var e, i = {};
        for(var u in bn(!0, t, i, null), bn(!1, r, i, null), n)(e = n[u]).h.push({
            $: "fx",
            a: i[u] || {
                i: f,
                j: f
            }
        }), rn(e);
    }
    function bn(n, t, r, e) {
        switch(t.$){
            case 1:
                var i = t.k, u = function(n, t, r, e) {
                    function i(n) {
                        for(var t = r; t; t = t.t)n = t.s(n);
                        return n;
                    }
                    return A2(n ? un[t].e : un[t].f, i, e);
                }(n, i, e, t.l);
                return void (r[i] = function(n, t, r) {
                    return r = r || {
                        i: f,
                        j: f
                    }, n ? r.i = s(t, r.i) : r.j = s(t, r.j), r;
                }(n, u, r[i]));
            case 2:
                for(var o = t.m; o.b; o = o.b)bn(n, o.a, r, e);
                return;
            case 3:
                return void bn(n, t.o, r, {
                    s: t.n,
                    t: e
                });
        }
    }
    var vn = "undefined" != typeof document ? document : {};
    function hn(n, t) {
        n.appendChild(t);
    }
    function pn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var gn = F2(function(n, t) {
        return F2(function(r, e) {
            for(var i = [], u = 0; e.b; e = e.b){
                var o = e.a;
                u += o.b || 0, i.push(o);
            }
            return u += i.length, {
                $: 1,
                c: t,
                d: jn(r),
                e: i,
                f: n,
                b: u
            };
        });
    })(void 0);
    F2(function(n, t) {
        return F2(function(r, e) {
            for(var i = [], u = 0; e.b; e = e.b){
                var o = e.a;
                u += o.b.b || 0, i.push(o);
            }
            return u += i.length, {
                $: 2,
                c: t,
                d: jn(r),
                e: i,
                f: n,
                b: u
            };
        });
    })(void 0);
    var mn, yn = F2(function(n, t) {
        return {
            $: "a0",
            n: n,
            o: t
        };
    }), $n = F2(function(n, t) {
        return {
            $: "a1",
            n: n,
            o: t
        };
    }), wn = F2(function(n, t) {
        return {
            $: "a2",
            n: n,
            o: t
        };
    }), kn = F2(function(n, t) {
        return {
            $: "a3",
            n: n,
            o: t
        };
    }), _n = /^script$/i, An = /^(formAction$)/i, xn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function jn(n) {
        for(var t = {}; n.b; n = n.b){
            var r = n.a, e = r.$, i = r.n, u = r.o;
            if ("a2" !== e) {
                var o = t[e] || (t[e] = {});
                "a3" === e && "class" === i ? qn(o, i, u) : o[i] = u;
            } else "className" === i ? qn(t, i, u) : t[i] = u;
        }
        return t;
    }
    function qn(n, t, r) {
        var e = n[t];
        n[t] = e ? e + " " + r : r;
    }
    function Nn(n, t) {
        var r = n.$;
        if (5 === r) return Nn(n.k || (n.k = n.m()), t);
        if (0 === r) {
            var e = vn.createTextNode(n.a);
            return e.created_by_elm = !0, e;
        }
        if (4 === r) {
            for(var i = n.k, u = n.j; 4 === i.$;)"object" != typeof u ? u = [
                u,
                i.j
            ] : u.push(i.j), i = i.k;
            var o, a = {
                j: u,
                p: t
            };
            return (o = Nn(i, a)).elm_event_node_ref = a, o;
        }
        if (3 === r) return Tn(o = n.h(n.g), t, n.d), o;
        (o = n.f ? vn.createElementNS(n.f, n.c) : vn.createElement(n.c)).created_by_elm = !0, Tn(o, t, n.d);
        for(var c = n.e, f = 0; c.length > f; f++)hn(o, Nn(1 === r ? c[f] : c[f].b, t));
        return o;
    }
    function Tn(n, t, r) {
        for(var e in r){
            var i = r[e];
            "a1" === e ? On(n, i) : "a0" === e ? Ln(n, t, i) : "a3" === e ? zn(n, i) : "a4" === e ? En(n, i) : ("value" !== e && "checked" !== e || n[e] !== i) && (n[e] = i);
        }
    }
    function On(n, t) {
        var r = n.style;
        for(var e in t)r[e] = t[e];
    }
    function zn(n, t) {
        for(var r in t){
            var e = t[r];
            void 0 !== e ? n.setAttribute(r, e) : n.removeAttribute(r);
        }
    }
    function En(n, t) {
        for(var r in t){
            var e = t[r], i = e.f, u = e.o;
            void 0 !== u ? n.setAttributeNS(i, r, u) : n.removeAttributeNS(i, r);
        }
    }
    function Ln(n, t, r) {
        var e = n.elmFs || (n.elmFs = {});
        for(var i in r){
            var u = r[i], o = e[i];
            if (u) {
                if (o) {
                    if (o.q.$ === u.$) {
                        o.q = u;
                        continue;
                    }
                    n.removeEventListener(i, o);
                }
                o = Sn(t, u), n.addEventListener(i, o, mn && {
                    passive: 2 > tr(u)
                }), e[i] = o;
            } else n.removeEventListener(i, o), e[i] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                mn = !0;
            }
        }));
    } catch (n) {}
    function Sn(n, t) {
        function r(t) {
            var e = r.q, i = R(e.a, t);
            if (Kt(i)) {
                for(var u, o = tr(e), a = i.a, c = o ? 3 > o ? a.a : a.o : a, f = 1 == o ? a.b : 3 == o && a.L, s = (f && t.stopPropagation(), (2 == o ? a.b : 3 == o && a.I) && t.preventDefault(), n); u = s.j;){
                    if ("function" == typeof u) c = u(c);
                    else for(var l = u.length; l--;)c = u[l](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return r.q = t, r;
    }
    function Cn(n, t) {
        return n.$ == t.$ && G(n.a, t.a);
    }
    function Fn(n, t, r, e) {
        var i = {
            $: t,
            r: r,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(i), i;
    }
    function Bn(n, t, r, e) {
        if (n !== t) {
            var i = n.$, u = t.$;
            if (i !== u) {
                if (1 !== i || 2 !== u) return void Fn(r, 0, e, t);
                t = function(n) {
                    for(var t = n.e, r = t.length, e = Array(r), i = 0; r > i; i++)e[i] = t[i].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(t), u = 1;
            }
            switch(u){
                case 5:
                    for(var o = n.l, a = t.l, c = o.length, f = c === a.length; f && c--;)f = o[c] === a[c];
                    if (f) return void (t.k = n.k);
                    t.k = t.m();
                    var s = [];
                    return Bn(n.k, t.k, s, 0), void (s.length > 0 && Fn(r, 1, e, s));
                case 4:
                    for(var l = n.j, d = t.j, b = !1, v = n.k; 4 === v.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    for(var h = t.k; 4 === h.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        h.j
                    ] : d.push(h.j), h = h.k;
                    return b && l.length !== d.length ? void Fn(r, 0, e, t) : ((b ? function(n, t) {
                        for(var r = 0; n.length > r; r++)if (n[r] !== t[r]) return !1;
                        return !0;
                    }(l, d) : l === d) || Fn(r, 2, e, d), void Bn(v, h, r, e + 1));
                case 0:
                    return void (n.a !== t.a && Fn(r, 3, e, t.a));
                case 1:
                    return void Dn(n, t, r, e, In);
                case 2:
                    return void Dn(n, t, r, e, Rn);
                case 3:
                    if (n.h !== t.h) return void Fn(r, 0, e, t);
                    var p = Mn(n.d, t.d);
                    p && Fn(r, 4, e, p);
                    var g = t.i(n.g, t.g);
                    return void (g && Fn(r, 5, e, g));
            }
        }
    }
    function Dn(n, t, r, e, i) {
        if (n.c === t.c && n.f === t.f) {
            var u = Mn(n.d, t.d);
            u && Fn(r, 4, e, u), i(n, t, r, e);
        } else Fn(r, 0, e, t);
    }
    function Mn(n, t, r) {
        var e;
        for(var i in n)if ("a1" !== i && "a0" !== i && "a3" !== i && "a4" !== i) {
            if (i in t) {
                var u = n[i], o = t[i];
                u === o && "value" !== i && "checked" !== i || "a0" === r && Cn(u, o) || ((e = e || {})[i] = o);
            } else (e = e || {})[i] = r ? "a1" === r ? "" : "a0" === r || "a3" === r ? void 0 : {
                f: n[i].f,
                o: void 0
            } : "string" == typeof n[i] ? "" : null;
        } else {
            var a = Mn(n[i], t[i] || {}, i);
            a && ((e = e || {})[i] = a);
        }
        for(var c in t)c in n || ((e = e || {})[c] = t[c]);
        return e;
    }
    function In(n, t, r, e) {
        var i = n.e, u = t.e, o = i.length, a = u.length;
        o > a ? Fn(r, 6, e, {
            v: a,
            i: o - a
        }) : a > o && Fn(r, 7, e, {
            v: o,
            e: u
        });
        for(var c = a > o ? o : a, f = 0; c > f; f++){
            var s = i[f];
            Bn(s, u[f], r, ++e), e += s.b || 0;
        }
    }
    function Rn(n, t, r, e) {
        for(var i = [], u = {}, o = [], a = n.e, c = t.e, f = a.length, s = c.length, l = 0, d = 0, b = e; f > l && s > d;){
            var v = (j = a[l]).a, h = (q = c[d]).a, p = j.b, g = q.b, m = void 0, y = void 0;
            if (v !== h) {
                var $ = a[l + 1], w = c[d + 1];
                if ($) {
                    var k = $.a, _ = $.b;
                    y = h === k;
                }
                if (w) {
                    var A = w.a, x = w.b;
                    m = v === A;
                }
                if (m && y) Bn(p, x, i, ++b), Jn(u, i, v, g, d, o), b += p.b || 0, Pn(u, i, v, _, ++b), b += _.b || 0, l += 2, d += 2;
                else if (m) b++, Jn(u, i, h, g, d, o), Bn(p, x, i, b), b += p.b || 0, l += 1, d += 2;
                else if (y) Pn(u, i, v, p, ++b), b += p.b || 0, Bn(_, g, i, ++b), b += _.b || 0, l += 2, d += 1;
                else {
                    if (!$ || k !== A) break;
                    Pn(u, i, v, p, ++b), Jn(u, i, h, g, d, o), b += p.b || 0, Bn(_, x, i, ++b), b += _.b || 0, l += 2, d += 2;
                }
            } else Bn(p, g, i, ++b), b += p.b || 0, l++, d++;
        }
        for(; f > l;){
            var j;
            b++, Pn(u, i, (j = a[l]).a, p = j.b, b), b += p.b || 0, l++;
        }
        for(; s > d;){
            var q, N = N || [];
            Jn(u, i, (q = c[d]).a, q.b, void 0, N), d++;
        }
        (i.length > 0 || o.length > 0 || N) && Fn(r, 8, e, {
            w: i,
            x: o,
            y: N
        });
    }
    var Wn = "_elmW6BL";
    function Jn(n, t, r, e, i, u) {
        var o = n[r];
        if (!o) return u.push({
            r: i,
            A: o = {
                c: 0,
                z: e,
                r: i,
                s: void 0
            }
        }), void (n[r] = o);
        if (1 === o.c) {
            u.push({
                r: i,
                A: o
            }), o.c = 2;
            var a = [];
            return Bn(o.z, e, a, o.r), o.r = i, void (o.s.s = {
                w: a,
                A: o
            });
        }
        Jn(n, t, r + Wn, e, i, u);
    }
    function Pn(n, t, r, e, i) {
        var u = n[r];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var o = [];
                return Bn(e, u.z, o, i), void Fn(t, 9, i, {
                    w: o,
                    A: u
                });
            }
            Pn(n, t, r + Wn, e, i);
        } else {
            var a = Fn(t, 9, i, void 0);
            n[r] = {
                c: 1,
                z: e,
                r: i,
                s: a
            };
        }
    }
    function Xn(n, t, r, e) {
        Gn(n, t, r, 0, 0, t.b, e);
    }
    function Gn(n, t, r, e, i, u, o) {
        for(var a = r[e], c = a.r; c === i;){
            var f = a.$;
            if (1 === f) Xn(n, t.k, a.s, o);
            else if (8 === f) a.t = n, a.u = o, (s = a.s.w).length > 0 && Gn(n, t, s, 0, i, u, o);
            else if (9 === f) {
                a.t = n, a.u = o;
                var s, l = a.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Gn(n, t, s, 0, i, u, o));
            } else a.t = n, a.u = o;
            if (!(a = r[++e]) || (c = a.r) > u) return e;
        }
        var d = t.$;
        if (4 === d) {
            for(var b = t.k; 4 === b.$;)b = b.k;
            return Gn(n, b, r, e, i + 1, u, n.elm_event_node_ref);
        }
        for(var v = t.e, h = n.childNodes, p = 0, g = 0; Math.max(v.length, h.length) > p; p++, g++){
            i++;
            var m = 1 === d ? v[p] : v[p].b, y = i + (m.b || 0);
            if (h.length > v.length) for(; !h[g].created_by_elm;)console.log("INFO 1: skipping DOM"), g++;
            if (v.length > h.length && (h[g] ? (console.log("WARN 1: redrawing DOM"), Yn(h[g], v[p], o)) : (console.log("WARN 2: redrawing DOM"), n.appendChild(Nn(v[p], o)))), h.length === v.length && (h[g].created_by_elm || (console.log("WARN 3: redrawing DOM"), Yn(h[g], v[p], o))), 1 === v[p].$ && (h[g].tagName || "").toLowerCase() !== v[p].c.toLowerCase() && (console.log("WARN 4: redrawing DOM"), Yn(h[g], v[p], o)), !(i > c || c > y || (a = r[e = Gn(h[g], m, r, e, i, y, o)]) && (c = a.r) <= u)) return e;
            i = y;
        }
        return e;
    }
    function Hn(n, t) {
        for(var r = 0; t.length > r; r++){
            var e = t[r], i = e.t, u = Un(i, e);
            i === n && (n = u);
        }
        return n;
    }
    function Un(n, t) {
        switch(t.$){
            case 0:
                return Yn(n, t.s, t.u);
            case 4:
                return Tn(n, t.u, t.s), n;
            case 3:
                return n.replaceData(0, n.length, t.s), n;
            case 1:
                return Hn(n, t.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = t.s : n.elm_event_node_ref = {
                    j: t.s,
                    p: t.u
                }, n;
            case 6:
                if (n.childNodes.length !== (c = t.s).i + c.v) {
                    console.log("INFO 0: using another logic");
                    for(var r = 0, e = n.childNodes.length - 1; c.i > r;){
                        var i = n.childNodes[e];
                        i.created_by_elm && (n.removeChild(i), r++), e--;
                    }
                    return n;
                }
                for(var u = 0; c.i > u; u++)n.removeChild(n.childNodes[c.v]);
                return n;
            case 7:
                for(var o = (c = t.s).e, a = n.childNodes[u = c.v]; o.length > u; u++)n.insertBefore(Nn(o[u], t.u), a);
                return n;
            case 9:
                var c;
                if (!(c = t.s)) return n.parentNode.removeChild(n), n;
                var f = c.A;
                return void 0 !== f.r && n.parentNode.removeChild(n), f.s = Hn(n, c.w), n;
            case 8:
                return function(n, t) {
                    var r = t.s, e = function(n, t) {
                        if (n) {
                            for(var r = vn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var i = n[e].A;
                                hn(r, 2 === i.c ? i.s : Nn(i.z, t.u));
                            }
                            return r;
                        }
                    }(r.y, t);
                    n = Hn(n, r.w);
                    for(var i = r.x, u = 0; i.length > u; u++){
                        var o = i[u], a = o.A, c = 2 === a.c ? a.s : Nn(a.z, t.u);
                        n.insertBefore(c, n.childNodes[o.r]);
                    }
                    return e && hn(n, e), n;
                }(n, t);
            case 5:
                return t.s(n);
            default:
                p(10);
        }
    }
    function Yn(n, t, r) {
        var e = n.parentNode, i = Nn(t, r);
        return i.elm_event_node_ref || (i.elm_event_node_ref = n.elm_event_node_ref), e && i !== n && e.replaceChild(i, n), i;
    }
    function Vn(n) {
        if (n.created_by_elm = !0, 3 === n.nodeType) return pn(n.textContent);
        if (1 !== n.nodeType) return pn("");
        for(var t = f, r = n.attributes, e = r.length; e--;){
            var i = r[e];
            t = s(A2(kn, i.name, i.value), t);
        }
        var u = n.tagName.toLowerCase(), o = f, a = n.childNodes;
        for(e = a.length; e--;)o = s(Vn(a[e]), o);
        return A3(gn, u, t, o);
    }
    var Kn = F4(function(n, t, r, e) {
        return function(n, t, r, e, i, u) {
            var o = A2(I, n, t ? t.flags : void 0);
            Kt(o) || p(2);
            var a = {}, c = r(o.a), f = c.a, s = u(d, f), l = function(n, t) {
                var r;
                for(var e in un){
                    var i = un[e];
                    i.a && ((r = r || {})[e] = i.a(e, t)), n[e] = on(i, t);
                }
                return r;
            }(a, d);
            function d(n, t) {
                var r = A2(e, n, f);
                s(f = r.a, t), ln(a, r.b, i(f));
            }
            return ln(a, c.b, i(f)), l ? {
                ports: l
            } : {};
        }(t, e, n.av, n.aD, n.aB, function(t, r) {
            var i = n.aE, u = e.node, o = Vn(u);
            return function(n, t) {
                t(n);
                var r = 0;
                function e() {
                    r = 1 === r ? 0 : (Qn(e), t(n), 1);
                }
                return function(i, u) {
                    n = i, u ? (t(n), 2 === r && (r = 1)) : (0 === r && Qn(e), r = 2);
                };
            }(r, function(n) {
                var r = i(n), e = function(n, t) {
                    var r = [];
                    return Bn(n, t, r, 0), r;
                }(o, r);
                u = function(n, t, r, e) {
                    return 0 === r.length ? n : (Xn(n, t, r, e), Hn(n, r));
                }(u, o, e, t), o = r;
            });
        });
    }), Qn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Zn = 1, nt = 2, tt = 0, rt = l, et = F3(function(n, t, r) {
        for(;;){
            if (-2 === r.$) return t;
            var e = r.d, i = n, u = A3(n, r.b, r.c, A3(et, n, t, r.e));
            n = i, t = u, r = e;
        }
    }), it = function(n) {
        return A3(et, F3(function(n, t, r) {
            return A2(rt, u(n, t), r);
        }), f, n);
    }, ut = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ot = F2(function(n, t) {
        return {
            $: 3,
            a: n,
            b: t
        };
    }), at = F2(function(n, t) {
        return {
            $: 0,
            a: n,
            b: t
        };
    }), ct = F2(function(n, t) {
        return {
            $: 1,
            a: n,
            b: t
        };
    }), ft = function(n) {
        return {
            $: 0,
            a: n
        };
    }, st = function(n) {
        return {
            $: 2,
            a: n
        };
    }, lt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dt = {
        $: 1
    }, bt = k, vt = a, ht = U, pt = A, gt = F2(function(n, t) {
        return A2(w, n, function(n) {
            for(var t = []; n.b; n = n.b)t.push(n.a);
            return t;
        }(t));
    }), mt = F2(function(n, t) {
        return d(A2($, n, t));
    }), yt = function(n) {
        return A2(gt, "\n    ", A2(mt, "\n", n));
    }, $t = F3(function(n, t, r) {
        for(;;){
            if (!r.b) return t;
            var e = r.b, i = n, u = A2(n, r.a, t);
            n = i, t = u, r = e;
        }
    }), wt = function(n) {
        return A3($t, F2(function(n, t) {
            return t + 1;
        }), 0, n);
    }, kt = b, _t = F3(function(n, t, r) {
        for(;;){
            if (e(n, t) >= 1) return r;
            var i = n, u = t - 1, o = A2(rt, t, r);
            n = i, t = u, r = o;
        }
    }), At = F2(function(n, t) {
        return A3(_t, n, t, f);
    }), xt = F2(function(n, t) {
        return A3(kt, n, A2(At, 0, wt(t) - 1), t);
    }), jt = function(n) {
        var t = n.charCodeAt(0);
        return 55296 > t || t > 56319 ? t : 1024 * (t - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, qt = function(n) {
        var t = jt(n);
        return t >= 97 && 122 >= t;
    }, Nt = function(n) {
        var t = jt(n);
        return 90 >= t && t >= 65;
    }, Tt = function(n) {
        return qt(n) || Nt(n) || function(n) {
            var t = jt(n);
            return 57 >= t && t >= 48;
        }(n);
    }, Ot = function(n) {
        return A3($t, rt, f, n);
    }, zt = F2(function(n, t) {
        return "\n\n(" + pt(n + 1) + ") " + yt(Et(t));
    }), Et = function(n) {
        return A2(Lt, n, f);
    }, Lt = F2(function(n, t) {
        n: for(;;)switch(n.$){
            case 0:
                var r = n.a, e = n.b, i = function() {
                    var n, t, e = (t = (n = r).charCodeAt(0), isNaN(t) ? dt : lt(55296 > t || t > 56319 ? u(n[0], n.slice(1)) : u(n[0] + n[1], n.slice(2))));
                    if (1 === e.$) return !1;
                    var i, o = e.a, a = o.b;
                    return (qt(i = o.a) || Nt(i)) && A2(bt, Tt, a);
                }();
                n = e, t = A2(rt, i ? "." + r : "['" + r + "']", t);
                continue n;
            case 1:
                e = n.b;
                var o = "[" + pt(n.a) + "]";
                n = e, t = A2(rt, o, t);
                continue n;
            case 2:
                var a = n.a;
                if (a.b) {
                    if (a.b.b) {
                        var c = (t.b ? "The Json.Decode.oneOf at json" + A2(gt, "", Ot(t)) : "Json.Decode.oneOf") + " failed in the following " + pt(wt(a)) + " ways:";
                        return A2(gt, "\n\n", A2(rt, c, A2(xt, zt, a)));
                    }
                    n = e = a.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (t.b ? " at json" + A2(gt, "", Ot(t)) : "!");
            default:
                var f = n.a, s = n.b;
                return (c = t.b ? "Problem with the value at json" + A2(gt, "", Ot(t)) + ":\n\n    " : "Problem with the given value:\n\n") + yt(A2(ht, 4, s)) + "\n\n" + f;
        }
    }), St = 32, Ct = F4(function(n, t, r, e) {
        return {
            $: 0,
            a: n,
            b: t,
            c: r,
            d: e
        };
    }), Ft = [], Bt = g, Dt = F2(function(n, t) {
        return y(t) / y(n);
    }), Mt = Bt(A2(Dt, 2, St)), It = A4(Ct, 0, Mt, Ft, Ft), Rt = v, Wt = m, Jt = function(n) {
        return n.length;
    }, Pt = F2(function(n, t) {
        return e(n, t) > 0 ? n : t;
    }), Xt = h, Gt = F2(function(n, t) {
        for(;;){
            var r = A2(Xt, St, n), e = r.b, i = A2(rt, {
                $: 0,
                a: r.a
            }, t);
            if (!e.b) return Ot(i);
            n = e, t = i;
        }
    }), Ht = F2(function(n, t) {
        for(;;){
            var r = Bt(t / St);
            if (1 === r) return A2(Xt, St, n).a;
            n = A2(Gt, n, f), t = r;
        }
    }), Ut = F2(function(n, t) {
        if (t.a) {
            var r = t.a * St, e = Wt(A2(Dt, St, r - 1)), i = n ? Ot(t.d) : t.d, u = A2(Ht, i, t.a);
            return A4(Ct, Jt(t.c) + r, A2(Pt, 5, e * Mt), u, t.c);
        }
        return A4(Ct, Jt(t.c), Mt, Ft, t.c);
    }), Yt = F5(function(n, t, r, e, i) {
        for(;;){
            if (0 > t) return A2(Ut, !1, {
                d: e,
                a: r / St | 0,
                c: i
            });
            var u = {
                $: 1,
                a: A3(Rt, St, t, n)
            };
            t -= St, e = A2(rt, u, e);
        }
    }), Vt = F2(function(n, t) {
        if (n > 0) {
            var r = n % St;
            return A5(Yt, t, n - r - St, n, f, A3(Rt, r, n - r, t));
        }
        return It;
    }), Kt = function(n) {
        return !n.$;
    }, Qt = S, Zt = C, nr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tr = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, rr = function(n) {
        return n;
    }, er = _, ir = function(n) {
        return n.length;
    }, ur = function(n) {
        return "" === n;
    }, or = Y, ar = or(0), cr = F4(function(n, t, r, e) {
        if (e.b) {
            var i = e.a, u = e.b;
            if (u.b) {
                var o = u.a, a = u.b;
                if (a.b) {
                    var c = a.a, f = a.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, i, A2(n, o, A2(n, c, A2(n, f.a, r > 500 ? A3($t, n, t, Ot(s)) : A4(cr, n, t, r + 1, s)))));
                    }
                    return A2(n, i, A2(n, o, A2(n, c, t)));
                }
                return A2(n, i, A2(n, o, t));
            }
            return A2(n, i, t);
        }
        return t;
    }), fr = F3(function(n, t, r) {
        return A4(cr, n, t, 0, r);
    }), sr = F2(function(n, t) {
        return A3(fr, F2(function(t, r) {
            return A2(rt, n(t), r);
        }), f, t);
    }), lr = K, dr = F2(function(n, t) {
        return A2(lr, function(t) {
            return or(n(t));
        }, t);
    }), br = F3(function(n, t, r) {
        return A2(lr, function(t) {
            return A2(lr, function(r) {
                return or(A2(n, t, r));
            }, r);
        }, t);
    }), vr = an, hr = F2(function(n, t) {
        var r = t;
        return function(n) {
            return V(function(t) {
                t(Y(Z(n)));
            });
        }(A2(lr, vr(n), r));
    });
    un.Task = {
        b: ar,
        c: F3(function(n, t) {
            var r;
            return A2(dr, function() {
                return 0;
            }, (r = A2(sr, hr(n), t), A3(fr, br(rt), or(f), r)));
        }),
        d: F3(function() {
            return or(0);
        }),
        e: F2(function(n, t) {
            return A2(dr, n, t);
        }),
        f: undefined
    };
    var pr = Kn, gr = F3(function(n, t, r) {
        return t(n(r));
    }), mr = M, yr = {
        $: -2
    }, $r = yr, wr = F5(function(n, t, r, e, i) {
        return {
            $: -1,
            a: n,
            b: t,
            c: r,
            d: e,
            e: i
        };
    }), kr = F5(function(n, t, r, e, i) {
        if (-1 !== i.$ || i.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(wr, n, t, r, e, i);
            var u = e.d;
            return o = e.e, A5(wr, 0, e.b, e.c, A5(wr, 1, u.b, u.c, u.d, u.e), A5(wr, 1, t, r, o, i));
        }
        var o, a = i.b, c = i.c, f = i.d, s = i.e;
        return -1 !== e.$ || e.a ? A5(wr, n, a, c, A5(wr, 0, t, r, e, f), s) : A5(wr, 0, t, r, A5(wr, 1, e.b, e.c, e.d, o = e.e), A5(wr, 1, a, c, f, s));
    }), _r = i, Ar = F3(function(n, t, r) {
        if (-2 === r.$) return A5(wr, 0, n, t, yr, yr);
        var e = r.a, i = r.b, u = r.c, o = r.d, a = r.e;
        switch(A2(_r, n, i)){
            case 0:
                return A5(kr, e, i, u, A3(Ar, n, t, o), a);
            case 1:
                return A5(wr, e, i, t, o, a);
            default:
                return A5(kr, e, i, u, o, A3(Ar, n, t, a));
        }
    }), xr = F3(function(n, t, r) {
        var e = A3(Ar, n, t, r);
        return -1 !== e.$ || e.a ? e : A5(wr, 1, e.b, e.c, e.d, e.e);
    }), jr = function(n) {
        return A3($t, F2(function(n, t) {
            return A3(xr, n.a, n.b, t);
        }), $r, n);
    }, qr = function(n) {
        return A2(Qt, jr, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, Nr = z, Tr = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Or = function(n) {
        return {
            $: 11,
            g: n
        };
    }, zr = function(n) {
        return Or(d([
            A2(Qt, lt, n),
            nr(dt)
        ]));
    }, Er = F2(function(n, t) {
        return u(n, t);
    }), Lr = O, Sr = F2(function(n, t) {
        return t.$ ? n : t.a;
    }), Cr = function(n) {
        return A2(Qt, Sr(""), zr(A2(Nr, "meta", A2(Qt, A2(gr, it, A2(gr, sr(function(n) {
            var t = n.a, r = n.b, e = r.b;
            return r.a ? t + ": " + e : t + "\n" + e + "\n@end";
        }), A2(gr, gt("\n\n"), function(t) {
            return n ? "\x3c!--\n\n" + t + "\n\n--\x3e\n\n\n" : "\n\x3c!--\n" + t + "\n--\x3e";
        }))), qr(Or(d([
            A2(Qt, Er(!0), Lr),
            A2(Qt, A2(gr, gt("\n"), Er(!1)), Tr(Lr))
        ])))))));
    }, Fr = q, Br = N, Dr = A, Mr = j, Ir = T, Rr = zr(A2(Nr, "attr", Or(d([
        Lr,
        A2(Qt, A2(gr, it, A2(gr, sr(function(n) {
            return n.a + '="' + n.b + '"';
        }), gt(" "))), qr(Or(d([
            Lr,
            A2(Qt, pt, Mr),
            A2(Qt, Dr, Br),
            A2(Qt, function(n) {
                return n ? "true" : "false";
            }, Fr),
            A2(Qt, ht(0), Ir)
        ]))))
    ])))), Wr = F2(function(n, t) {
        return t.$ ? dt : lt(n(t.a));
    }), Jr = A2(Qt, A2(gr, Wr(function(n) {
        return "\x3c!-- " + n + " --\x3e";
    }), Sr("")), Rr), Pr = function(n) {
        return A2(Qt, function(t) {
            return ur(t) ? n : t + "\n" + n;
        }, Jr);
    }, Xr = function(n) {
        return d(n.split(/\r\n|\r|\n/g));
    }, Gr = F2(function(n, t) {
        return A2(gt, "\n", A2(sr, function(t) {
            return c(n, t);
        }, Xr(t)));
    }), Hr = L, Ur = function(n) {
        return A2(Qt, function(t) {
            return c(n, t);
        }, Jr);
    }, Yr = D, Vr = A2(Qt, Sr(!1), zr(A2(Nr, "playback", Fr))), Kr = A2(Qt, Wr(pt), zr(A2(Nr, "start", Mr))), Qr = A2(Qt, Wr(pt), zr(A2(Nr, "stop", Mr))), Zr = zr(A2(Nr, "voice", Lr)), ne = function(n) {
        return A6(Yr, F5(function(n, t, r, e, i) {
            var o, a, c, f = (a = u(t, r)).a.$ ? dt : lt(1 === a.b.$ ? a.a.a : a.a.a + "-" + a.b.a), s = (o = u(e, i)).a ? lt(1 === o.b.$ ? "!>" : "!> " + o.b.a) : dt;
            return u(1 === (c = u(f, s)).a.$ ? c.b.$ ? "" : c.b.a : 1 === c.b.$ ? c.a.a : c.a.a + " " + c.b.a, n);
        }), n, Kr, Qr, Vr, Zr);
    }, te = function(n) {
        return {
            $: 1,
            a: n
        };
    }, re = F, ee = F2(function(n, t) {
        return A4(re, F3(function(t, r, e) {
            return "<" + t + " " + A2(Sr, "", e) + ">" + A2(Sr, "", n) + r + A2(Sr, "", n) + "</" + t + ">";
        }), A2(Nr, "htmlTag", Lr), t, Rr);
    }), ie = F3(function(n, t, r) {
        return n > 0 ? A3(ie, n >> 1, c(t, t), 1 & n ? c(r, t) : r) : r;
    }), ue = F2(function(n, t) {
        return A3(ie, n, t, "");
    }), oe = A2(Hr, function(n) {
        var t = n.a, r = n.b;
        if (1 === r.$) return nr(t);
        var i = r.a;
        return 0 > e(i, ir(t)) ? te("length must be greater than or equal to the length of the solution") : nr(c(t, A2(ue, i - ir(t), " ")));
    }, A3(Zt, Er, A2(Nr, "solution", Lr), zr(A2(Nr, "length", Mr)))), ae = B, ce = F3(function(n, t, r) {
        var e = n(t);
        return e.$ ? r : A2(rt, e.a, r);
    }), fe = F2(function(n, t) {
        return A3(fr, ce(n), f, t);
    }), se = function(n) {
        return d([
            n
        ]);
    }, le = Or(d([
        A2(Qt, se, Mr),
        Tr(Mr),
        A2(Qt, A2(gr, xt(Er), fe(function(n) {
            return n.b ? lt(n.a) : dt;
        })), Tr(Fr))
    ])), de = F2(function(n, t) {
        for(;;){
            if (!t.b) return !1;
            var r = t.b;
            if (n(t.a)) return !0;
            t = r;
        }
    }), be = F2(function(n, t) {
        return A2(de, function(t) {
            return function(n, t) {
                for(var e, i = [], u = r(n, t, 0, i); u && (e = i.pop()); u = r(e.a, e.b, 0, i));
                return u;
            }(t, n);
        }, t);
    }), ve = Or(d([
        Lr,
        A2(Qt, gt("\n"), Tr(Lr))
    ])), he = function(n) {
        return A2(Hr, Ur, A5(ae, F4(function(n, t, r, e) {
            return n + "[" + t + "](" + r + e + ")";
        }), A2(Nr, "linkType", A2(Hr, function(t) {
            switch(t){
                case "link":
                    return n ? te("in this context only multimedia links are supported") : nr("");
                case "image":
                    return nr("!");
                case "audio":
                    return nr("?");
                case "video":
                    return nr("!?");
                case "embed":
                    return nr("??");
                default:
                    return te("Only link, image, audio, video, and embed are supported");
            }
        }, Lr)), A2(Qt, Sr(""), zr(A2(Nr, "alt", $e()))), A2(Nr, "url", Lr), A2(Qt, A2(gr, Wr(function(n) {
            return ' "' + n + '"';
        }), Sr("")), zr(A2(Nr, "title", $e())))));
    }, pe = function(n) {
        switch(n){
            case "bold":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "__" + n + "__";
                }, ge()));
            case "italic":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "_" + n + "_";
                }, ge()));
            case "formula":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "$ " + n + " $";
                }, ge()));
            case "symbol":
            case "string":
                return A2(Hr, Ur, A2(Nr, "body", Lr));
            case "strike":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "~" + n + "~";
                }, ge()));
            case "sup":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "^" + n + "^";
                }, ge()));
            case "underline":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "~~" + n + "~~";
                }, ge()));
            case "code":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "`" + n + "`";
                }, A2(Nr, "body", Lr)));
            case "effect":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "{" + n.a + "}{" + n.b + "}";
                }, ne(ge())));
            case "footnote":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "[^" + n + "]";
                }, ge()));
            case "html":
                return A2(ee, dt, ge());
            case "link":
                return he(!1);
            case "script":
                return A3(Zt, F2(function(n, t) {
                    return "<script " + A2(Sr, "", t) + ">" + n + "<\/script>";
                }), A2(Nr, "body", ve), Rr);
            case "input":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "[[" + n + "]]";
                }, oe));
            case "select":
                return A2(Hr, Ur, A2(Qt, function(n) {
                    return "[[ " + n + " ]]";
                }, me()));
            default:
                return te("unknown inline type " + n);
        }
    };
    function ge() {
        return A2(Nr, "body", Or(d([
            ke(),
            A2(Qt, gt(""), Tr(Or(d([
                ke(),
                Lr
            ])))),
            ve
        ])));
    }
    function me() {
        return A3(Zt, F2(function(n, t) {
            return A2(gt, " | ", A2(xt, F2(function(n, r) {
                return A2(be, n, t) ? "( " + r + " )" : r;
            }), n));
        }), ye(), A2(Nr, "solution", le));
    }
    function ye() {
        return A2(Nr, "body", Tr($e()));
    }
    function $e() {
        return Or(d([
            A2(Qt, gt(" "), Tr(we())),
            we()
        ]));
    }
    function we() {
        return Or(d([
            ke(),
            Lr
        ]));
    }
    function ke() {
        return A2(Hr, pe, A2(Nr, "type", Lr));
    }
    var _e = ge();
    ge = function() {
        return _e;
    };
    var Ae = me();
    me = function() {
        return Ae;
    };
    var xe = ye();
    ye = function() {
        return xe;
    };
    var je = $e();
    $e = function() {
        return je;
    };
    var qe = we();
    we = function() {
        return qe;
    };
    var Ne = ke();
    ke = function() {
        return Ne;
    };
    var Te = A3(Zt, F2(function(n, t) {
        return "``` ascii" + t + "\n" + n + "\n```";
    }), A2(Nr, "body", ve), A2(Qt, A2(gr, Wr(vt("  ")), Sr("")), zr(A2(Nr, "title", je)))), Oe = A2(Qt, Gr("    "), A2(Nr, "body", ve)), ze = A5(ae, F4(function(n, t, r, e) {
        var i = o(t, r, e);
        return i.a.$ ? "```\n" + n + "\n```" : 1 === i.b.$ ? "``` " + i.a.a + "\n" + n + "\n```" : 1 === i.c.$ ? "``` " + i.a.a + "   " + i.b.a + "\n" + n + "\n```" : "``` " + i.a.a + "   " + (i.c.a ? "-" : "+") + i.b.a + "\n" + n + "\n```";
    }), A2(Nr, "body", ve), zr(A2(Nr, "language", Lr)), zr(A2(Nr, "title", Lr)), zr(A2(Nr, "closed", Fr))), Ee = A2(Qt, Sr(""), zr(A2(Qt, function(n) {
        return "\n" + n;
    }, A2(Nr, "execute", ve)))), Le = Or(d([
        ve,
        Ne,
        A2(Qt, gt(""), Tr(je))
    ])), Se = A3(Zt, F2(function(n, t) {
        return c(A2(gt, "\n", n), t);
    }), A2(Nr, "body", Tr(ze)), Ee), Ce = zr(A2(Nr, "hints", A2(Qt, A2(gr, sr(vt("[[?]] ")), gt("\n")), Tr(je)))), Fe = F3(function(n, t, r) {
        for(;;){
            if (0 >= t) return n;
            n = A2(rt, r, n), t -= 1;
        }
    }), Be = F2(function(n, t) {
        return A3(Fe, f, n, t);
    }), De = A4(re, F3(function(n, t, r) {
        var e = A2(Sr, A2(Be, wt(n), "-----"), A2(Wr, sr(function(n) {
            switch(n){
                case "left":
                    return ":----";
                case "right":
                    return "----:";
                case "center":
                    return ":---:";
                default:
                    return "-----";
            }
        }), t));
        return A2(gt, "\n", A2(sr, function(n) {
            return "| " + n + " |";
        }, c(d([
            A2(gt, " | ", n)
        ]), c(d([
            A2(gt, " | ", e)
        ]), A2(sr, gt(" | "), r)))));
    }), A2(Nr, "head", Tr(je)), zr(A2(Nr, "orientation", Tr(Lr))), A2(Nr, "body", Tr(Tr(je)))), Me = A4(re, F3(function(n, t, r) {
        return c(A2(gt, "\n", A2(xt, F2(function(n, r) {
            return A2(be, n, t) ? "- [X] " + r : "- [ ] " + r;
        }), n)), r);
    }), A2(Nr, "body", Tr(je)), A2(Qt, Sr(f), zr(A2(Nr, "done", le))), Ee), Ie = function(n) {
        switch(n){
            case "paragraph":
                return A2(Hr, Pr, A2(Nr, "body", Le));
            case "line":
                return Pr("---");
            case "comment":
                return A2(Hr, Pr, A4(re, F3(function(n, t, r) {
                    return "--{{" + n + (1 === t.$ ? "" : " " + t.a) + "}}--\n" + r;
                }), A2(Hr, function(n) {
                    return n.$ ? te("a comment requires start parameter") : nr(n.a);
                }, Kr), Zr, A2(Nr, "body", Le)));
            case "gallery":
                return A2(Hr, Pr, A2(Qt, gt("\n"), A2(Nr, "body", Tr(he(!0)))));
            case "formula":
                return A2(Hr, Pr, A2(Qt, function(n) {
                    return "$$ " + n + " $$";
                }, A2(Nr, "body", ve)));
            case "effect":
                return A2(Hr, Pr, Or(d([
                    A2(Qt, function(n) {
                        return "{{" + n.a + "}}\n" + n.b;
                    }, ne(A2(Nr, "body", Ue()))),
                    A2(Hr, function(n) {
                        return n.b ? n.b.b ? A2(Qt, function(n) {
                            return "{{" + n.a + "}}\n**********************\n\n" + n.b + "\n\n**********************";
                        }, ne(nr(A2(gt, "\n\n", n)))) : A2(Qt, function(n) {
                            return "{{" + n.a + "}}\n" + n.b;
                        }, ne(nr(n.a))) : te("An effect must have at least one block.");
                    }, A2(Nr, "body", Tr(Ue())))
                ])));
            case "quote":
                return A2(Hr, Pr, We());
            case "html":
                return A2(ee, lt("\n\n"), Re());
            case "ascii":
                return A2(Hr, Pr, Te);
            case "chart":
                return A2(Hr, Pr, Oe);
            case "table":
                return A2(Hr, Pr, De);
            case "itemize":
                return A2(Hr, Pr, Ge());
            case "enumerate":
                return A2(Hr, Pr, He());
            case "code":
                return A2(Hr, Pr, A3(Zt, F2(function(n, t) {
                    return ur(t) ? n : n + "\n" + t;
                }), ze, Ee));
            case "project":
                return A2(Hr, Pr, Se);
            case "tasks":
                return A2(Hr, Pr, Me);
            case "quiz":
                return A2(Hr, Pr, Je());
            default:
                return Ne;
        }
    };
    function Re() {
        return A2(Nr, "body", Or(d([
            Ye(),
            A2(Qt, gt("\n\n"), Tr(Ye())),
            ve
        ])));
    }
    function We() {
        return A3(Zt, F2(function(n, t) {
            return A2(Gr, "> ", 1 === t.$ ? n : n + "\n\n-- " + t.a);
        }), A2(Nr, "body", Or(d([
            Xe(),
            Ue()
        ]))), zr(A2(Nr, "by", Ue())));
    }
    function Je() {
        return A5(ae, F4(function(n, t, r, e) {
            return c(n, 1 === t.$ ? c(r, e) : c(t.a, c(r, e)));
        }), Ve(), Ce, Pe(), Ee);
    }
    function Pe() {
        return A2(Qt, Sr(""), zr(A2(Qt, function(n) {
            return "\n************************\n\n" + n + "\n\n************************";
        }, A2(Nr, "answer", Or(d([
            Xe(),
            Ue()
        ]))))));
    }
    function Xe() {
        return A2(Qt, gt("\n\n"), Tr(Or(d([
            Lr,
            Ye(),
            Le
        ]))));
    }
    function Ge() {
        return A2(Qt, A2(gr, sr(A2(gr, Xr, A2(gr, xt(F2(function(n, t) {
            return n ? "  " + t : "* " + t;
        })), gt("\n")))), gt("\n\n")), A2(Nr, "body", Tr(Or(d([
            A2(Qt, gt("\n\n"), Tr(Ue())),
            Ue()
        ])))));
    }
    function He() {
        return A2(Qt, A2(gr, xt(function(n) {
            return A2(gr, Xr, A2(gr, xt(F2(function(t, r) {
                return t ? "   " + r : pt(n + 1) + ". " + r;
            })), gt("\n")));
        }), gt("\n\n")), A2(Nr, "body", Tr(Or(d([
            A2(Qt, gt("\n\n"), Tr(Ue())),
            Ue()
        ])))));
    }
    function Ue() {
        return Or(d([
            Lr,
            Ye()
        ]));
    }
    function Ye() {
        return A2(Hr, Ie, A2(Nr, "type", Lr));
    }
    function Ve() {
        return A2(Hr, function(n) {
            switch(n){
                case "input":
                    return A2(Qt, function(n) {
                        return "[[" + n + "]]\n";
                    }, oe);
                case "selection":
                    return A2(Qt, function(n) {
                        return "[[" + n + "]]\n";
                    }, Ae);
                case "single-choice":
                    return A3(Zt, F2(function(n, t) {
                        return A2(gt, "\n", A2(xt, F2(function(n, r) {
                            return A2(be, n, t) ? "[(X)] " + r : "[( )] " + r;
                        }), n)) + "\n";
                    }), xe, A2(Nr, "solution", le));
                case "multiple-choice":
                    return A3(Zt, F2(function(n, t) {
                        return A2(gt, "\n", A2(xt, F2(function(n, r) {
                            return A2(be, n, t) ? "[[X]] " + r : "[[ ]] " + r;
                        }), n)) + "\n";
                    }), xe, A2(Nr, "solution", le));
                case "matrix":
                    return A3(Zt, F2(function(n, t) {
                        return "[ " + A2(gt, " ", A2(sr, function(n) {
                            return A2(er, ")", n) ? "[ " + n + " ]" : "( " + n + " )";
                        }, n)) + " ]\n" + A2(gt, "\n", A2(sr, function(t) {
                            var r = t.a, e = t.b, i = t.c;
                            return "[  " + A2(gt, " ", A2(xt, F2(function(n) {
                                return A2(be, n, e) ? r ? "(X)" : "[X]" : r ? "( )" : "[ ]";
                            }), n)) + "  ] " + i;
                        }, t)) + "\n";
                    }), A2(Nr, "head", Tr(Or(d([
                        Ne,
                        je
                    ])))), A2(Nr, "body", Tr(Or(d([
                        A2(Nr, "single-choice", A3(Zt, F2(function(n, t) {
                            return o(!0, n, t);
                        }), A2(Nr, "solution", le), A2(Nr, "body", je))),
                        A2(Nr, "multiple-choice", A3(Zt, F2(function(n, t) {
                            return o(!1, n, t);
                        }), A2(Nr, "solution", le), A2(Nr, "body", je)))
                    ])))));
                case "gap-text":
                    return A2(Nr, "body", Ue());
                case "generic":
                    return nr("[[!]]\n");
                default:
                    return te('Supported quiz types are "input", "selection", "single-choice", "multiple-choice", "matrix", "gap-text", and "generic".');
            }
        }, A2(Nr, "quizType", Lr));
    }
    var Ke = Re();
    Re = function() {
        return Ke;
    };
    var Qe = We();
    We = function() {
        return Qe;
    };
    var Ze = Je();
    Je = function() {
        return Ze;
    };
    var ni = Pe();
    Pe = function() {
        return ni;
    };
    var ti = Xe();
    Xe = function() {
        return ti;
    };
    var ri = Ge();
    Ge = function() {
        return ri;
    };
    var ei = He();
    He = function() {
        return ei;
    };
    var ii = Ue();
    Ue = function() {
        return ii;
    };
    var ui = Ye();
    Ye = function() {
        return ui;
    };
    var oi = Ve();
    Ve = function() {
        return oi;
    };
    var ai, ci = A2(Nr, "body", Or(d([
        ii,
        A2(Qt, gt("\n\n"), Tr(Or(d([
            ii,
            Le
        ]))))
    ]))), fi = A2(Hr, function(n) {
        return n > 0 && 7 > n ? nr(A2(ue, n, "#")) : te("Indentation must be between 1 and 6");
    }, A2(Nr, "indent", Mr)), si = A3(Zt, F2(function(n, t) {
        return n + " " + t;
    }), fi, A2(Nr, "title", je)), li = A4(re, F3(function(n, t, r) {
        return n + (r + "\n\n") + t;
    }), si, ci, Cr(!1)), di = A2(Qt, gt("\n\n\n"), A2(Nr, "sections", Tr(li))), bi = A3(Zt, F2(function(n, t) {
        return c(n, t);
    }), Cr(!0), di), vi = F2(function(n, t) {
        return t.$ ? ut(n(t.a)) : ft(t.a);
    }), hi = A2(gr, mr(bi), vi(Et)), pi = cn(f), gi = function(n) {
        var t = A2(mr, Ir, n);
        return t.$ ? n : A2(ht, 2, t.a);
    }, mi = cn(f), yi = F2(function(n, t) {
        var r = n;
        return u(function(n, t) {
            var r = {};
            for(var e in n)r[e] = n[e];
            for(var e in t)r[e] = t[e];
            return r;
        }(t, {
            E: gi(r),
            F: hi(r)
        }), pi);
    }), $i = F2(function(n, t) {
        return A2(kn, function(n) {
            return An.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return xn.test(n) ? "" : n;
        }(t));
    }), wi = gn("div"), ki = function(n) {
        return gn(function(n) {
            return _n.test(n) ? "p" : n;
        }(n));
    }, _i = function(n) {
        return u(n, !0);
    }, Ai = yn, xi = F2(function(n, t) {
        return A2(Ai, n, {
            $: 1,
            a: t
        });
    }), ji = A2(F2(function(n, t) {
        return A3(fr, Nr, t, n);
    }), d([
        "target",
        "value"
    ]), Lr), qi = $n, Ni = pn, Ti = gn("textarea"), Oi = function(n) {
        return n;
    }, zi = F2(function(n, t) {
        return A2(wn, n, Oi(t));
    })("value");
    ai = {
        Demo: {
            init: pr({
                av: function(n) {
                    var t = ur(n) ? '{\n  "meta": {\n    "author": "LiaScript",\n    "version": "1.3",\n    "lang": "de"\n  },\n  "sections": [\n    {\n      "meta": {\n        "author": "LiaScript",\n        "email": "author@web.de"\n      },\n      "indent": 1,\n      "title": "Base",\n      "body": "In the simplest case, a section consists of two strings for one for the title and one for the body. The indentation is a required value between 0 and 6 and defines the number of starting hash-tags. For the __title__ and the __body__ elements it is already possible to use *LiaScript-syntax* directly."\n    },\n    {\n      "indent": 2,\n      "title": "Blocks",\n      "body": [\n        "__If you want to have multiple paragraphs:__",\n        "- Simply add multiple strings into a list",\n        "- All strings will be separated by a single newline ..."\n      ]\n    },\n    {\n      "indent": 3,\n      "title": "`paragraph` or `p`",\n      "body": [\n        {\n          "paragraph": "A paragraph is either a string,"\n        },\n        {\n          "paragraph": [\n            "but it can also",\n            {\n              "bold": [\n                {\n                  "string": "be a simple list"\n                }\n              ]\n            },\n            {\n              "superscript": [\n                "of multiple ",\n                {\n                  "formula": "inline elements"\n                }\n              ]\n            },\n            "."\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`unordered list` or `ul`",\n      "indent": 3,\n      "body": [\n        {\n          "unordered list": [\n            "is either a list of strings",\n            {\n              "paragraph": ", or a list of further Blocks an tables.",\n              "attributes": {\n                "style": "color: red;"\n              }\n            },\n            [\n              "But it is also possible",\n              {\n                "ul": ["put group multiple elements within", "a single list"]\n              }\n            ]\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`ordered list` or `ol`",\n      "indent": 3,\n      "body": [\n        {\n          "ordered list": [\n            "behave similar to unordered lists",\n            {\n              "paragraph": ", the only difference is, that the blocks are identified by their appearance.",\n              "attributes": {\n                "style": "color: red;"\n              }\n            },\n            [\n              "Grouping works exactly the same way,",\n              {\n                "ul": ["simply put multiple elements", "into a single list"]\n              }\n            ]\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`effect`",\n      "indent": 3,\n      "body": [\n        "An effect can be an animation step or a playback or both things combined:",\n        {\n          "effect": {\n            "begin": 1,\n            "end": 3,\n            "body": "Hallo welt"\n          }\n        },\n        "or",\n        {\n          "horizontal rule": null\n        }\n      ]\n    },\n    {\n      "title": "`horizontal rule` or `hr`",\n      "indent": 3,\n      "body": [\n        "A horizontal rule is a simple line that separates two blocks:",\n        {\n          "hr": null\n        },\n        "or",\n        {\n          "horizontal rule": null\n        }\n      ]\n    },\n    {\n      "title": "`blockquote` or `q`",\n      "indent": 3,\n      "body": [\n        {\n          "blockquote": "This can also be a simple string..."\n        },\n        {\n          "hr": null\n        },\n        {\n          "blockquote": [\n            "__A list of multiple strings__",\n            "These are interpreted as separate blocks"\n          ]\n        },\n        {\n          "hr": null\n        },\n        {\n          "blockquote": [\n            {\n              "paragraph": "Or a combination"\n            },\n            {\n              "q": [\n                "of various different blocks",\n                {\n                  "ul": ["lists", "blockquotes", "tables", "etc."]\n                }\n              ]\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`citation` or `cite`",\n      "indent": 3,\n      "body": [\n        {\n          "paragraph": "Citations are a special LiaScript case of a blockquote, which will be rendered differently, but behave like normal blockquotes."\n        },\n        {\n          "citation": [\n            {\n              "p": [\n                "If you want your children to be intelligent, read them fairy tales.",\n                "If you want them to be more intelligent, read them more fairy tales."\n              ]\n            }\n          ],\n          "by": "Albert Einstein"\n        }\n      ]\n    },\n    {\n      "title": "`comment`",\n      "indent": 3,\n      "body": [\n        {\n          "comment": [\n            "Comments in LiaScript are these parts that are spoken out loud.",\n            "They will be displayed only in `Textbook` mode.",\n            "Every comment requires an `id`, to mark the animation step, when it should be spoken out loud.",\n            "Additionally you can set the voice, which is optional in contrast to the id"\n          ],\n          "id": 1,\n          "voice": "Ukrainian Female"\n        }\n      ]\n    },\n    {\n      "title": "`ascii art` or `ascii`",\n      "indent": 3,\n      "body": [\n        {\n          "ascii": [\n            "+------+   +-----+   +-----+   +-----+",\n            "|      |   |     |   |     |   |     |",\n            "| Foo  +--\x3e| Bar +---+ Baz |<--+ Moo |",\n            "|      |   |     |   |     |   |     |",\n            "+------+   +-----+   +--+--+   +-----+",\n            "              ^         |",\n            "              |         V",\n            ".-------------+-----------------------.",\n            "| Hello here and there and everywhere |",\n            "\'-------------------------------------\'"\n          ],\n          "title": "  Title is optional and will be displayed as an image __caption__"\n        }\n      ]\n    },\n    {\n      "title": "`chart` or `diagram`",\n      "indent": 3,\n      "body": [\n        {\n          "chart": [\n            "                            diagram title       ",\n            "1.5 |           *                     (* stars) ",\n            "    |                                           ",\n            "  y |        *      *                           ",\n            "  - |      *          *                         ",\n            "  a |     *             *       *               ",\n            "  x |    *                 *                    ",\n            "  i |   *                                       ",\n            "  s |  *                                        ",\n            "    | *                              *        * ",\n            "  0 +------------------------------------------ ",\n            "   2.0              x-axis                100   "\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`quiz`",\n      "indent": 3,\n      "body": "asfda"\n    },\n    {\n      "title": "`text`",\n      "indent": 4,\n      "body": [\n        "What did the fish say, when he hit the wall?",\n        {\n          "quiz": "text",\n          "solution": "dam"\n        }\n      ]\n    },\n    {\n      "title": "`selection`",\n      "indent": 4,\n      "body": [\n        "The solution is defined by its position in the option list",\n        {\n          "quiz": "selection",\n          "solution": 1,\n          "options": [\n            "option 0",\n            "option 1",\n            [\n              {\n                "bold": "this is Bold and wrong"\n              }\n            ]\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`single-choice`",\n      "indent": 4,\n      "body": [\n        "What did the fish say, when he hit the wall?",\n        {\n          "quiz": "single-choice",\n          "solution": 1,\n          "options": [\n            "option 0",\n            "option 1",\n            [\n              {\n                "bold": "option 3"\n              }\n            ]\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`multiple-choice`",\n      "indent": 4,\n      "body": [\n        "What did the fish say, when he hit the wall?",\n        {\n          "quiz": "multiple-choice",\n          "solution": 1,\n          "options": [\n            "option 0",\n            "option 1",\n            [\n              {\n                "bold": "option 3"\n              }\n            ]\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`gap-text`",\n      "indent": 4,\n      "body": [\n        "What did the fish say, when he hit the wall?",\n        {\n          "quiz": "gap-text",\n          "body": {\n            "p": [\n              {\n                "bold": "Some Inlines"\n              },\n              " ",\n              {\n                "input": "text",\n                "solution": "damn"\n              },\n              " some more test ",\n              {\n                "input": "selection",\n                "solution": 1,\n                "options": ["option1", "option2", "option3"]\n              },\n              " some more test "\n            ]\n          }\n        }\n      ]\n    },\n    {\n      "title": "Tweaks",\n      "indent": 4,\n      "body": [\n        "The solution is defined by its position in the option list...",\n        "... But, as there are multiple options, you can define also multiple solutions too.",\n        {\n          "quiz": "selection",\n          "solution": [0, 2],\n          "options": [\n            "option 0",\n            "option 1",\n            [\n              {\n                "bold": "this is Bold"\n              }\n            ]\n          ],\n          "hints": ["hint number one", "the second and last hint"],\n          "answer": [\n            "These blocks will only be visible...",\n            "... if and only if, the quiz is solved",\n            "or if the user clicks onto the resolve button."\n          ],\n          "attributes": {\n            "data-trials": 5\n          }\n        }\n      ]\n    },\n    {\n      "title": "`gallery`",\n      "indent": 3,\n      "body": [\n        "A gallery is simply a collection of multimedia links",\n        {\n          "gallery": [\n            {\n              "link": "image",\n              "url": "https://liascript.github.io/img/LiveEditor.jpg",\n              "alt": "LiaScript Live-Editor",\n              "title": "More and optional information."\n            },\n            {\n              "link": "audio",\n              "url": "https://soundcloud.com/magnetic-magazine/magnetics-elm-podcast-one-more",\n              "alt": "Magnetic\'s ELM Podcast: One More Summer Sun"\n            },\n            {\n              "link": "video",\n              "url": "https://www.youtube.com/watch?v=q_Usix3nyGA",\n              "alt": "Some random video"\n            },\n            {\n              "link": "embed",\n              "url": "https://falstad.com/circuit/circuitjs.html"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "title": "`tasks`",\n      "indent": 3,\n      "body": [\n        "Tasks are defined by a task and by a done list:",\n        {\n          "tasks": ["task 1", "task 2", "task 3"],\n          "done": [true, false, true]\n        },\n        "Additionally it is possible to define a done list with only checked positions:",\n        {\n          "tasks": ["task 1", "task 2", "task 3"],\n          "done": [0, 2]\n        }\n      ]\n    },\n    {\n      "title": "`table`",\n      "indent": 3,\n      "body": [\n        "Tables are defined by a head and a row, the orientation is optional",\n        {\n          "table": {\n            "head": ["head 1", "head 2", [{ "bold": "head 3" }]],\n            "orientation": ["left", "right", "center"],\n            "rows": [\n              ["1", "2", "3"],\n              ["4", "5", "6"],\n              ["7", "8", "9"]\n            ]\n          }\n        }\n      ]\n    }\n  ]\n}' : n;
                    return u({
                        E: gi(t),
                        F: hi(t)
                    }, pi);
                },
                aB: function() {
                    return mi;
                },
                aD: yi,
                aE: function(n) {
                    var t;
                    return A2(wi, d([
                        A2(qi, "display", "flex")
                    ]), d([
                        A2(Ti, d([
                            (t = rr, A2(xi, "input", A2(Qt, _i, A2(Qt, t, ji)))),
                            zi(n.E),
                            A2(qi, "width", "50%"),
                            A2(qi, "height", "98.5vh")
                        ]), f),
                        A2(wi, d([
                            A2(qi, "width", "50%"),
                            A2(qi, "white-space", "pre"),
                            A2(qi, "height", "98.5vh")
                        ]), d([
                            function() {
                                var t = n.F;
                                if (t.$) {
                                    var r = t.a;
                                    return A2(wi, d([
                                        A2(qi, "color", "red")
                                    ]), d([
                                        Ni(r)
                                    ]));
                                }
                                var e = t.a;
                                return A3(ki, "textarea", d([
                                    A2($i, "value", e),
                                    A2(qi, "width", "100%"),
                                    A2(qi, "height", "98.5vh")
                                ]), d([
                                    Ni(e)
                                ]));
                            }()
                        ]))
                    ]));
                }
            })(Lr)(0)
        }
    }, n.Elm ? function n(t, r) {
        for(var e in r)e in t ? "init" == e ? p(6) : n(t[e], r[e]) : t[e] = r[e];
    }(n.Elm, ai) : n.Elm = ai;
}($1b47f5dea7b52a6c$exports);


var $06283cc7d52c2deb$exports = {};
$06283cc7d52c2deb$exports = JSON.parse('{"meta":{"author":"LiaScript","version":"1.3","lang":"de"},"sections":[{"meta":{"author":"LiaScript","email":"author@web.de"},"indent":1,"title":"Base","body":"In the simplessssst cadsde, a ssssdsasfdasfdection consists of two strings for one for thes title and odne for the body. The3 indentation is a required value beessssn 0 and sssss6 sasn22222djjjj defiwness the nussmbewwr of startinwg hash-tags. For the __tieeetle__ and asdfthe __body__ elements it issasdfasd already possibjjjjhhlshhhhe to use *LiaScsript-syntax* disrectly."},{"title":"Codee--------------------------------","indent":2,"body":[{"type":"quiz","quizType":"input","solution":"liascripsssssst","hints":["asdfasfd","asdfasfd"],"answer":["asdasdfasdfasfdasdf","asdfasfdasdfafdsafsd"]},{"type":"code","body":["// asdfasdf","// asdfalsdfafsd"],"language":"cpp","title":"tester.cpp","execute":["<script>","@input","</script>"],"attr":{"data-type":"none"}}]},{"title":"Tables--------------------------------","indent":2,"body":[{"type":"table","head":["1","2","3"],"body":[["a","b","c"],["a","b",{"type":"italic","body":"italic text","attr":"custom-style"}]],"attr":{"data-type":"none"}}]},{"title":"XXXXXXXXXXXXXXXXXX ordered list","indent":2,"body":[{"type":"tasks","body":["XXXXXXXXX","YYYYYYYYY","dddddddd"],"done":[false,false,true]}]},{"title":"ordered list","indent":2,"body":[{"type":"enumerate","body":["XXXXXXXXX","YYYYYYYYY",{"type":"quote","body":["111111","222222"]},"dddddddd"]}]},{"title":"unordered list","indent":2,"body":[{"type":"itemize","body":["XXXXXXXXX","YYYYYYYYY",{"type":"quote","body":["111111","222222"]},"dddddddd"]}]},{"title":"BlockQuote","indent":2,"body":[{"type":"quote","by":"asdfasfd","body":["XXXXXXXXX","YYYYYYYYY",{"type":"quote","body":["111111","222222"]},"dddddddd"]}]},{"meta":{"author":"LiaScript","email":"author@web.de"},"indent":2,"title":"Paragraph","body":[{"type":"paragraph","body":"A paragraph can always be a simple string, that can already include __Markdown__/~LiaScript~."},{"type":"line"},{"type":"paragraph","body":"It is possible to attach attributes to a block, with any kind of HTML parameter for styling and more...","attr":{"style":"color: red;","class":"css testing","id":"someId"}},{"type":"paragraph","body":["It is possible","ssssssssssssss",{"type":"input","solution":"jjjj","length":22,"attr":{"style":"color: red"}},{"type":"select","solution":1,"body":["a","b","c",{"type":"html","htmlTag":"span","attr":{"style":"color: red"},"body":["asdfasdfas"]}],"attr":{"style":"color: red"}},{"type":"html","htmlTag":"span","attr":{"style":"color: red"},"body":["asdfasdfas"]},{"type":"bold","body":"bold text","attr":{"class":"highlighted"}},{"type":"italic","body":"italic text","attr":"custom-style"},{"type":"formula","body":"E = mc^2","attr":{"display":"block"}},{"type":"symbol","body":"\u2192","attr":{"direction":"right"}},{"type":"string","body":"plain text"},{"type":"strike","body":"struck through text","attr":{"reason":"outdated"}},{"type":"sup","body":"superscript","attr":null},{"type":"underline","body":"underlined text","attr":null},{"type":"code","body":"const x = 42;","attr":{"lang":"javascript"}},{"type":"effect","body":"animated text","attr":null,"start":0,"stop":5,"playback":true,"voice":"alice"},{"type":"footnote","body":"footnote reference","attr":{"id":"fn1"}},{"type":"html","htmlTag":"div","body":"custom HTML content","attr":{"class":"container"}},{"type":"link","linkType":"link","alt":"Link text","url":"https://example.com","title":"Hover title","attr":{"target":"_blank"}},{"type":"script","body":["// comment","console.log(\'Hello\');"],"attr":{"type":"text/javascript"}}]}]}]}');


const $ad2440d0c36a0440$var$app = (0, $1b47f5dea7b52a6c$exports.Elm).Demo.init({
    node: document.getElementById('app'),
    flags: JSON.stringify($06283cc7d52c2deb$exports)
});


//# sourceMappingURL=demo.031a96b7.js.map
